import commonUtil from '../../../../../utils/commonUtil';

const errorObject = require('../../../../../utils/errors/LP_GR_error.json');

const formData = {
  addresses: {
    nickname: '',
    newNickname: '',
    middleName: '',
    firstName: '',
    maternalName: '',
    lastName: '',
    country: 'México',
    postalCode: '',
    state: '',
    stateId: '',
    city: '',
    delegationMunicipality: '',
    delegationMunicipalityId: '',
    colony: '',
    otherColony: '',
    exteriorNumber: '',
    interiorNumber: '',
    building: '',
    neighbourhood: '',
    neighbourhoodId: '',
    particularPhoneCode: '',
    phoneNumber: '',
    cellular: '',
    address1: '',
    address2: '',
    address3: '',
  },
};

const userFullName = ({ currentUserData, currentUserMotherName, userData }) => {
  const { firstName, lastName, middleName, maternalName } = currentUserData;
  formData.addresses.firstName = (userData && userData.firstName) || firstName;
  formData.addresses.lastName = (userData && userData.lastName) || lastName;
  formData.addresses.middleName = middleName || '';
  formData.addresses.maternalName =
    (userData && userData.maternalName) || maternalName || currentUserMotherName || '';
};

export const nickNameValidation = ({ nickNameValue, userData, currentUserData, currentUserMotherName, deliveryAddressNickNames }) => {
  userFullName({ currentUserData, currentUserMotherName, userData });

  const nicknameInput = (typeof nickNameValue.getValue === 'function')
    ? nickNameValue.getValue()
    : '';

  const nickNameValidationConfig = [
    {
      functionRef: commonUtil.isValueAvailable,
      funcData: [nicknameInput],
      errorMessage: 'Ingresa un alias para esta dirección',
    },
    {
      functionRef: (value) =>
        !deliveryAddressNickNames.some(
          (existingNick) => existingNick.toLowerCase().trim() === value.toLowerCase().trim()
        ),
      funcData: [nicknameInput],
      errorMessage: 'Este alias ya está en uso. Ingresa uno diferente.',
    },
  ];

  const nickNameValid = commonUtil.validateTextInput(nickNameValidationConfig, nickNameValue, null);

  if (nickNameValid) {
    formData.addresses.nickname = userData.nickName
      ? userData.nickName
      : nicknameInput; // always send the original value in nickName IBM defect 9883

    if (formData.addresses.nickname !== nicknameInput) {
      formData.addresses.newNickname = nicknameInput;
    }
  }
  return nickNameValid;
};

export const postalCodeValidation = ({ postalCodeValue }) => {
  const postalCodeValidationConfig = [
    {
      functionRef: commonUtil.isValueAvailable,
      funcData: [postalCodeValue.getValue()],
      errorMessage: 'Ingresa el código postal',
    },
    {
      functionRef: commonUtil.validatePostalCode,
      funcData: [postalCodeValue.getValue()],
      errorMessage: 'El código postal no es válido.',
    },
  ];

  const postalCodeValid = commonUtil.validateTextInput(postalCodeValidationConfig, postalCodeValue, null);

  if (postalCodeValid) {
    formData.addresses.postalCode = postalCodeValue.getValue();
  }

  return postalCodeValid;
};

export const addressStateValidation = ({ selectorStateValue }) => {
  let addressStateValid = '';
  const addressStateValidationConfig = {
    functionRef: commonUtil.validateSelectedValue,
    funcData: [selectorStateValue.getSelectedIndex()],
    errorMessage: 'Selecciona una opción',
  };

  addressStateValid = commonUtil.validateSelecteTab(addressStateValidationConfig, selectorStateValue, null);

  if (addressStateValid) {
    formData.addresses.state = selectorStateValue.getValue();
    formData.addresses.stateId = selectorStateValue.getID();
  }
  return addressStateValid;
};

export const cityValidation = ({ cityValue }) => {
  const cityValidationConfig = [{
    functionRef: commonUtil.isValueAvailable,
    funcData: [cityValue.getValue()],
    errorMessage: 'Ingresa una ciudad',
  }, {
    functionRef: commonUtil.validateName,
    funcData: [cityValue.getValue(), 2, false],
    errorMessage: 'Nombre de ciudad inválido',
  }];

  const cityValid = commonUtil.validateTextInput(cityValidationConfig, cityValue, null);

  if (cityValid) {
    formData.addresses.city = cityValue.getValue();
  }
  return cityValid;
};

export const municipaltyValidation = ({ selectorMunicipaltyValue }) => {
  let municipaltyValid = '';
  let municipaltyValidationConfig = '';

  municipaltyValidationConfig = {
    functionRef: commonUtil.validateSelectedValue,
    funcData: [selectorMunicipaltyValue.getSelectedIndex()],
    errorMessage: 'Selecciona una opción',
  };

  municipaltyValid = commonUtil.validateSelecteTab(municipaltyValidationConfig, selectorMunicipaltyValue, null);

  if (municipaltyValid) {
    formData.addresses.delegationMunicipality = selectorMunicipaltyValue.getValue();
    formData.addresses.delegationMunicipalityId = selectorMunicipaltyValue.getID();
  }

  return municipaltyValid;
};

export const colonyValidation = ({
  selectorColonyValue,
  otherColonyValue,
  changeViewToText,
  showOtherColony,
}) => {
  let colonyValidationConfig = null;
  let colonyValid = '';

  if (!showOtherColony) {
    if (!changeViewToText) {
      colonyValidationConfig = {
        functionRef: commonUtil.validateSelectedValue,
        funcData: [selectorColonyValue.getSelectedIndex()],
        errorMessage: 'Selecciona una opción',
      };
    } else {
      colonyValidationConfig = [
        { functionRef: commonUtil.isValueAvailable,
          funcData: [selectorColonyValue.getValue()],
          errorMessage: commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.colony.required'),
        },
      ];
    }

    if (!changeViewToText) {
      colonyValid = commonUtil.validateSelecteTab(colonyValidationConfig, selectorColonyValue, null);
    } else {
      colonyValid = commonUtil.validateTextInput(colonyValidationConfig, selectorColonyValue, null);
    }

    if (colonyValid) {
      formData.addresses.colony = selectorColonyValue.getValue();
      formData.addresses.neighbourhood = selectorColonyValue.getValue();
      if (!changeViewToText) {
        formData.addresses.neighbourhoodId = selectorColonyValue.getID();
      } else {
        formData.addresses.neighbourhoodId = '0000';
      }
    }
  }

  // * For otherColony
  if (showOtherColony) {
    const otherColonyValidationConfig = [{
      functionRef: commonUtil.isValueAvailable,
      funcData: [otherColonyValue.getValue()],
      errorMessage: 'Ingresa una colonia',
    }];

    colonyValid = commonUtil.validateTextInput(otherColonyValidationConfig, otherColonyValue, null);
    if (colonyValid) {
      formData.addresses.neighbourhood = selectorColonyValue.getValue();
      formData.addresses.otherColony = otherColonyValue.getValue();
      formData.addresses.neighbourhoodId = '-2';
    }
  }

  return colonyValid;
};

export const streetValidation = ({ streetValue }) => {
  const streetValidationConfig = [
    { functionRef: commonUtil.isValueAvailable,
      funcData: [streetValue.getValue()],
      errorMessage: 'Ingresa una calle',
    },
  ];

  const streetValid = commonUtil.validateTextInput(streetValidationConfig, streetValue, null);

  if (streetValid) {
    formData.addresses.address1 = streetValue.getValue();
  }

  return streetValid;
};

export const outherNumberValidation = ({ outherNumberValue }) => {
  const outerNumberValidationConfig = [{
    functionRef: commonUtil.isValueAvailable,
    funcData: [outherNumberValue.getValue()],
    errorMessage: 'Ingresa un número ext.',
  },
  {
    functionRef: commonUtil.validateNumber,
    funcData: [outherNumberValue.getValue(), 1, true],
    errorMessage: 'Número ext. no es válido',
  }];

  const outerNumberValid = commonUtil.validateTextInput(outerNumberValidationConfig, outherNumberValue, null);

  if (outerNumberValid) {
    formData.addresses.exteriorNumber = outherNumberValue.getValue();
  }

  return outerNumberValid;
};

export const insideNumberValidation = ({ insideNumberValue }) => {
  let isInteriorNumberValid = true;

  if (insideNumberValue.getValue()) {
    const interiorNumberValidationConfig = [{
      functionRef: commonUtil.validateNumber,
      funcData: [insideNumberValue.getValue(), 1, true],
      errorMessage: commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.ineriorNumber.invalid'),
    }];

    isInteriorNumberValid = commonUtil.validateTextInput(interiorNumberValidationConfig, insideNumberValue, null);
  } else {
    insideNumberValue.setControlState(true, {}, { controlErrorClass: 'error', errorClass: 'error' });
  }

  if (isInteriorNumberValid) {
    formData.addresses.interiorNumber = insideNumberValue.getValue();
  }

  return isInteriorNumberValid;
};

export const buildingValidation = ({ buildingValue }) => {
  let isBuildingValid = true;

  if (buildingValue.getValue()) {
    const buildingValidationConfig = [{
      functionRef: commonUtil.validateLength,
      funcData: [buildingValue.getValue(), 1],
      errorMessage: commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.building.invalid'),
    }];
    isBuildingValid = commonUtil.validateTextInput(buildingValidationConfig, buildingValue, null);
  } else {
    buildingValue.setControlState(true, {}, { controlErrorClass: 'error', errorClass: 'error' });
  }

  if (isBuildingValid) {
    formData.addresses.building = buildingValue.getValue();
  }

  return isBuildingValid;
};

export const betweenStreetValidation = ({ betweenStreetValue }) => {
  let isBetweenStreetValid = true;

  if (betweenStreetValue.getValue()) {
    const betweenStreetValidationConfig = [{
      functionRef: commonUtil.validateLength,
      funcData: [betweenStreetValue.getValue(), 1],
      errorMessage: commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.betweenStreet.invalid'),
    }];

    isBetweenStreetValid = commonUtil.validateTextInput(betweenStreetValidationConfig, betweenStreetValue, null);
  } else {
    betweenStreetValue.setControlState(true, {}, { controlErrorClass: 'error', errorClass: 'error' });
  }
  if (isBetweenStreetValid) {
    formData.addresses.address2 = betweenStreetValue.getValue();
  }

  return isBetweenStreetValid;
};

export const andStreetValidation = ({ andStreetValue }) => {
  let andStreetValid = true;

  if (andStreetValue.getValue()) {
    const andStreetValidationConfig = [{
      functionRef: commonUtil.validateLength,
      funcData: [andStreetValue.getValue(), 1],
      errorMessage: commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.andStreet.invalid'),
    }];

    andStreetValid = commonUtil.validateTextInput(andStreetValidationConfig, andStreetValue, null);
  } else {
    andStreetValue.setControlState(true, {}, { controlErrorClass: 'error', errorClass: 'error' });
  }

  if (andStreetValid) {
    formData.addresses.address3 = andStreetValue.getValue();
  }

  return andStreetValid;
};


export const mobileValidation = ({ mobileValue }) => {
  const mobileValidationConfig = [{
    functionRef: commonUtil.isValueAvailable,
    funcData: [mobileValue.getValue()],
    errorMessage: 'Ingresa un núm. de teléfono celular',
  },
  {
    functionRef: commonUtil.validatePhoneNumber2,
    funcData: [mobileValue.getValue()],
    errorMessage: 'El núm de teléfono debe de ser de 10 dígitos',
  }];

  const mobilePhoneValid = commonUtil.validateTextInput(mobileValidationConfig, mobileValue, null);

  if (mobilePhoneValid) {
    formData.addresses.cellular = mobileValue.getValue();
  }

  return mobilePhoneValid;
};

export const privatePhoneTotalValidation = ({ privatePhoneValue }) => {
  let privatePhoneTotalValid = '';

  const privatePhoneValidationConfig = [{
    functionRef: commonUtil.isValueAvailable,
    funcData: [privatePhoneValue.getValue()],
    errorMessage: 'Ingresa un núm. de teléfono',
  },
  {
    functionRef: commonUtil.validatePhoneNumber2,
    funcData: [privatePhoneValue.getValue()],
    errorMessage: 'El núm de teléfono debe de ser de 10 dígitos',
  }];

  const privatePhoneValid = commonUtil.validateTextInput(privatePhoneValidationConfig, privatePhoneValue, null);

  if (privatePhoneValid) {
    const total = privatePhoneValue.getValue().length;

    if (total === 10) {
      privatePhoneTotalValid = true;
    } else {
      privatePhoneTotalValid = false;
    }

    privatePhoneValue.setControlState(
      privatePhoneTotalValid,
      commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.numberTotal'),
      { controlErrorClass: 'error', errorClass: 'error' },
    );
  }

  if (privatePhoneTotalValid) {
    formData.addresses.phoneNumber = (privatePhoneValue.getValue());
  }

  return !!privatePhoneTotalValid && privatePhoneValid;
};

export const focusValidation = ({ nickNameValid, postalCodeValid, addressStateValid, cityValid, streetValid, outerNumberValid, mobileValid, privatePhoneValid }) => { // TODO: anotherColonyValid
  if (!nickNameValid) {
    document.getElementById('nickName').focus();
  } else if (!postalCodeValid) {
    document.getElementById('postalCode').focus();
  } else if (!addressStateValid) {
    document.getElementById('addressState').focus();
  } else if (!cityValid) {
    document.getElementById('city').focus();
  } else if (!streetValid) {
    document.getElementById('street').focus();
  } else if (!outerNumberValid) {
    document.getElementById('outerNumber').focus();
  } else if (!mobileValid) {
    document.getElementById('mobile').focus();
  } else if (!privatePhoneValid) {
    document.getElementById('privatePhone').focus();
  }
};

export const formDataValidation = ({ validationFlag }) => {
  const addresses = {};
  return !validationFlag ? addresses : { addresses: { ...formData.addresses } };
};
